module.exports = __webpack_public_path__ + "img/31.107b3aa2.svg";